// Function to decode HTML entities
function decodeHtmlEntities(text) {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = text;
  return textarea.value;
}

// Truncate function with HTML decoding
const truncate = function(value, length, omission = '...') {
  if (!value || typeof value !== 'string') return '';

  // Decode HTML entities
  value = decodeHtmlEntities(value);

  // Truncate the text
  if (value.length <= length) {
    return value;
  } else {
    return value.substring(0, length) + omission;
  }
};

export default truncate;
